import { useIntl } from '@capsicum/common';
import { Divider, GenericDrawer, useRouter } from '@capsicum/common-web';
import styled from 'styled-components';

export type InsufficientRPDrawerProps = {
	amount: number | string;
	closeModal: () => void;
	description: string;
	onPress?: () => void;
	testID: string;
	title: string;
	walletAmount: number | string | undefined;
};

export const InsufficientRPDrawer = ({
	amount,
	closeModal,
	description,
	onPress,
	testID,
	title,
	walletAmount
}: InsufficientRPDrawerProps) => {
	const { $t } = useIntl();
	const router = useRouter();

	const auctionHomePage = () => {
		return router.push(`/fan-shop/rewards?tab=auctions`);
	};

	return (
		<GenericDrawer
			buttonText={$t('rewards.rpAuctions.stake')}
			description={description}
			isButtonFullWidth
			isButtonOnRow={false}
			secondaryActionButtonText={$t('rewards.rpAuctions.stakeLater')}
			testID={testID}
			title={title}
			onButtonPress={() => {
				onPress?.();

				closeModal();
			}}
			onSecondaryActionOnButtonPress={() => {
				auctionHomePage();

				closeModal();
			}}
		>
			<S.UserAmount>
				<S.UserAmountText>{$t('rewards.rpAuctions.rpBalance')}</S.UserAmountText>
				<S.UserAmountValue>{walletAmount}</S.UserAmountValue>
			</S.UserAmount>
			<S.StyledDivider orientation="horizontal" />
			<S.AmountNeededWrapper>
				<S.StyledText>{$t('rewards.rpAuctions.rpNeeded')}</S.StyledText>
				<S.StyledText>{amount}</S.StyledText>
			</S.AmountNeededWrapper>
		</GenericDrawer>
	);
};

namespace S {
	export const UserAmountText = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const UserAmountValue = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.destructive.enabled};
	`;

	export const UserAmount = styled.div`
		display: flex;
		padding: ${({ theme }) => `${theme.spacings.xxsmall} ${theme.spacings.small}`};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.unselected};
		${({ theme }) => theme.border.radius.medium}
		margin-top: ${({ theme }) => theme.spacings.small};
		flex-direction: row;
		justify-content: space-between;
	`;

	export const StyledDivider = styled(Divider)`
		margin: ${({ theme }) => theme.spacings.small} 0;
	`;

	export const AmountNeededWrapper = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: ${({ theme }) => theme.spacings.xsmall} 0;
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;

	export const StyledText = styled.div`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
